
import DataTable from '~/mixins/dataTable'
export default {
    name: 'MessagesComponent',
    mixins: [DataTable],
    middleware: ['checkAuth'],
    data: () => ({
        api: 'player/messages',
        page: 1,
    }),
    computed: {
        messages() {
            return this.$store.state.player.messages
        },
        headers() {
            return [
                { text: this.tl('message'), value: 'text' },
                { text: this.tl('includeBroadcast'), value: 'is_broadcast' },
                { text: this.tl('createAt'), value: 'created_at' },
            ]
        },
    },
    watch: {
        'customFilters.page'(v) {
            this.API()
        },
    },
    mounted() {
        this.customFilters = {
            start_date: '2021-01-01 00:00:00',
            end_date: this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59',
            is_broadcast: true,
            page: 1,
        }
        this.API()
    },
}
